import { z } from 'zod';
// Base schema for common message properties
const BaseMessageSchema = z.object({
    timestamp: z.number().optional(),
    messageId: z.string().optional(),
});
// Schema for STREAM_DATA message
const StreamDataMessageSchema = BaseMessageSchema.extend({
    type: z.literal('STREAM_DATA'),
    data: z.object({
        content: z.string(),
        role: z.enum(['assistant', 'user', 'function', 'system', 'error']),
        isLast: z.boolean().optional(),
        chatId: z.string().optional(),
        tokens: z
            .object({
            total: z.number(),
            completion: z.number(),
        })
            .optional(),
    }),
});
// Schema for USER_MESSAGE
const UserMessageSchema = BaseMessageSchema.extend({
    type: z.literal('USER_MESSAGE'),
    data: z.object({
        content: z.string(),
    }),
});
// Schema for CONNECTION_ESTABLISHED message
const ConnectionEstablishedMessageSchema = BaseMessageSchema.extend({
    type: z.literal('CONNECTION_ESTABLISHED'),
    data: z.object({
        chatId: z.string(),
    }),
});
// Schema for ERROR message
const ErrorMessageSchema = BaseMessageSchema.extend({
    type: z.literal('ERROR'),
    data: z.object({
        code: z.enum([
            'rate_limit',
            'api_error',
            'openai_error',
            'function_error',
            'validation_error',
            'unknown_error',
            'connection_error',
            'connection_closed',
        ]),
        message: z.string(),
        details: z.any().optional(),
    }),
});
// Schema for FUNCTION_CALL message
const FunctionCallMessageSchema = BaseMessageSchema.extend({
    type: z.literal('FUNCTION_CALL'),
    data: z.object({
        functionId: z.string(),
        name: z.string(),
        arguments: z.record(z.any()),
    }),
});
// Schema for FUNCTION_RESULT message
const FunctionResultMessageSchema = BaseMessageSchema.extend({
    type: z.literal('FUNCTION_RESULT'),
    data: z.object({
        functionId: z.string(),
        result: z.any(),
        error: z.string().optional(),
    }),
});
// Schema for MESSAGE_STARTED message
const MessageStartedMessageSchema = BaseMessageSchema.extend({
    type: z.literal('MESSAGE_STARTED'),
    data: z.object({
        tempId: z.string(),
        role: z.string(),
    }),
});
// Schema for MESSAGE_COMPLETED message
const MessageCompletedMessageSchema = BaseMessageSchema.extend({
    type: z.literal('MESSAGE_COMPLETED'),
    data: z.object({
        tempId: z.string(),
        finalId: z.string(),
    }),
});
// Combined discriminated union for all stream messages
export const StreamMessageSchema = z.discriminatedUnion('type', [
    StreamDataMessageSchema,
    UserMessageSchema,
    ConnectionEstablishedMessageSchema,
    ErrorMessageSchema,
    FunctionCallMessageSchema,
    FunctionResultMessageSchema,
    MessageStartedMessageSchema,
    MessageCompletedMessageSchema,
]);
//# sourceMappingURL=message-schema.js.map